export default "__VITE_ASSET__DqOHpZ7f__"